import React from 'react';
import { testimonials } from '../mock';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  return (
    <div className="min-h-screen pt-32">
      {/* Hero */}
      <section className="py-20">
        <div className="container-custom">
          <h1 className="heading-1 mb-8">TESTIMONIALS</h1>
          <p className="body-large max-w-3xl">
            From students and professionals who have engaged with the GPS Method™.
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-20">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="card-standard p-8">
                <Quote size={32} className="text-primary mb-6" />
                <p className="body-medium mb-6">"{testimonial.content}"</p>
                <div className="border-t border-border-light pt-4">
                  <p className="heading-6 text-primary">{testimonial.name}</p>
                  <p className="caption text-secondary">{testimonial.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Note */}
      <section className="py-20 bg-card">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <p className="body-medium text-secondary">
              These testimonials reflect individual experiences with the GPS Method™. Results vary based on commitment, practice, and readiness.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20">
        <div className="container-custom text-center">
          <h2 className="heading-3 mb-8 text-secondary">EXPERIENCE THE METHOD</h2>
          <a href="/school" className="btn-primary inline-flex items-center">
            Apply to the School
          </a>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;